import {RightList, User}		from '../../redux/user/interface';

export function ft_findUser(users: User[], findvalue?: string, email?: string) {
	const split = findvalue?.toLowerCase().split(' ');
	email = email?.toLowerCase();

	if (!split?.[0] || !split?.[1])
		return;

	const userExist = users.find((find) => {
		if (!find)
			return;

		const firstname = find.firstname.toLowerCase();
		const lastname = find.lastname.toLowerCase();

		return (
			(firstname === split[0] && lastname === split[1])
			|| (firstname === split[1] && lastname === split[0])
			|| (email && email === find.email.toLowerCase())
		);
	});

	return userExist?._id;
}

export function ft_checkRight(user: User, right: RightList) {
	if (!right || !user?.right)
		return false;

	const split = right.split('.');

	if (!split[1])
		return user.right[split[0]] && typeof user.right[split[0]] === 'boolean';
	if (!user.right[split[0]])
		return false;
	return user.right[split[0]][split[1]];
}